export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_CHANGE_EVENT = 'edana:language-change';
